import { createContext, useContext } from "react";

import { ProductRoomFormModelContext, type ProductRoomFormModelContextType } from "../../_shared/context/context";

export type ProductNewRoomFormModelContextType = {
	onUpdate: () => void;
} & ProductRoomFormModelContextType;

export const ProductNewRoomFormModelContext = createContext<ProductNewRoomFormModelContextType | null>(null);

export const ProductNewRoomFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductNewRoomFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductNewRoomFormModelContext.Provider value={value}>
			<ProductRoomFormModelContext.Provider value={value}>{children}</ProductRoomFormModelContext.Provider>
		</ProductNewRoomFormModelContext.Provider>
	);
};

export const useProductNewRoomFormModelContext = () => {
	const context = useContext(ProductNewRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductNewRoomFormModelContext must be used within a ProductNewRoomFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
